// Centralized builds data for the project

const Builds = [
  {
    id: 'b1',
    name: 'Pavlov',
    keyboardId: 'kb14',
    switchId: 'sunset_gleam',
    keycapId: 'metropolis',
    plateId: 'pc',
    soundDescriptors: ['clacky', 'bright'],
    audio: "/audio/pavlov/pavlov_sunsetgleam_cfoam.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: null,
    foam: ['Case foam', 'Plate foam'],
    mount: 'Gasket Tadpole',
  },
  {
    id: 'b2',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'uni',
    keycapId: 'dracula_r2',
    plateId: 'pp',
    soundDescriptors: ['deep', 'clacky', 'marbly'],
    audio: "/audio/neo65cu/neo65cu_kguni.mp3",
    youtube: "https://youtu.be/z2IT_cWMhp8",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neo65cu1.jpg',
    foam: [],
    mount: 'Top mount',
  },
  {
    id: 'b3',
    name: 'Isabell60',
    keyboardId: 'kb4',
    switchId: 'hyacinth_v2',
    keycapId: 'skidata_neo',
    plateId: 'alu',
    soundDescriptors: ['clacky', 'neutral'],
    audio: "/audio/isabell_hyacinth_pcfoam.mp3",
    youtube: "https://youtu.be/Hbo-0RB4c8Y",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/isabell601.jpg',
    foam: ['Plate foam', 'PE foam'],
    mount: 'Gasket',
  },
  {
    id: 'b4',
    name: 'Neo Ergo',
    keyboardId: 'kb13',
    switchId: 'macchiato',
    keycapId: 'darling',
    plateId: 'pp',
    soundDescriptors: ['deep', 'thocky', 'marbly'],
    audio: "/audio/neoergo/neoergo_macchiato_afoam.mp3",
    youtube: "https://youtu.be/QjSy4uSzoyg",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neoergo1.jpg',
    foam: ['Case foam', 'Plate foam', 'PE foam'],
    mount: 'Gasket',
  },
  {
    id: 'b5',
    name: 'Neo70',
    keyboardId: 'kb11',
    switchId: 'xinhai',
    keycapId: 'honor_dark',
    plateId: 'pom',
    soundDescriptors: ['clacky', 'bright', 'sharp'],
    audio: "/audio/neo70/neo70_xinhai.mp3", //reextract later
    youtube: "https://youtu.be/kDeaFMTZolE",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neo701.jpg',
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b6',
    name: 'Encore',
    keyboardId: 'kb6',
    switchId: 'mxblack',
    keycapId: 'modern_materials_stone',
    plateId: 'alu',
    soundDescriptors: ['clacky', 'scratchy', 'poppy'],
    audio: "/audio/encore/encore_mx2a.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: null,
    foam: [],
    mount: 'Green Lattice Block',
  },
  {
    id: 'b7',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'mxblack',
    keycapId: 'digital_nightmares',
    plateId: 'cf',
    soundDescriptors: ['poppy', 'scratchy'],
    audio: "/audio/neo65cu/neo65cu_mx2a.mp3",
    youtube: "https://youtu.be/rdfm4rdkT6g",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neo65cu2.jpg',
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b8',
    name: 'BD60',
    keyboardId: 'kb1',
    switchId: 'mxblack',
    keycapId: 'blossom',
    plateId: 'pc',
    soundDescriptors: ['poppy', 'bright'],
    audio: "/audio/bd60_mx2a.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: null,
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b9',
    name: 'Brutal65 V2',
    keyboardId: 'kb2',
    switchId: 'milky_yellow',
    keycapId: 'fuji',
    plateId: 'alu',
    soundDescriptors: ['clacky', 'bright'],
    audio: "/audio/brutal/brutal_milkyyellow_pcfoam.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: null,
    foam: ['Case foam', 'Plate foam'],
    mount: 'Gasket',
  },
  {
    id: 'b10',
    name: 'Mode Envoy',
    keyboardId: 'kb7',
    switchId: 'sunset_gleam',
    keycapId: 'dracula_r2',
    plateId: 'alu',
    soundDescriptors: [],
    audio: "/audio/envoy/envoypc_sunsetgleams.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: null,
    foam: [],
    mount: 'Black Lattice Block',
  },
  {
    id: 'b11',
    name: 'Neo Ergo',
    keyboardId: 'kb12',
    switchId: 'poro',
    keycapId: '8008_bloo',
    plateId: 'pp',
    soundDescriptors: [],
    audio: "/audio/neoergo/neoergo_poro_pcfoam.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: null,
    foam: ['Case foam', 'Plate foam'],
    mount: 'Gasket',
  },
  {
    id: 'b12',
    name: 'Neo Ergo',
    keyboardId: 'kb12',
    switchId: 'mxblack',
    keycapId: '8008',
    plateId: 'pp',
    soundDescriptors: ['scratchy', 'clacky'],
    audio: "/audio/neoergo/neoergo_mxblack.mp3", 
    youtube: "https://youtu.be/3e1m0vpaTco",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neoergogray1.jpg',
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b13',
    name: 'Neo70',
    keyboardId: 'kb11',
    switchId: 'nixie',
    keycapId: 'night_sakura',
    plateId: 'pom',
    soundDescriptors: ['scratchy', 'deep', 'poppy'],
    audio: "/audio/neo70/neo70_nixies.mp3", 
    youtube: "https://youtu.be/3e1m0vpaTco",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neo702.jpg',
    foam: [],
    mount: 'O-ring',
  },
  {
    id: 'b14',
    name: 'Krush65',
    keyboardId: 'kb5',
    switchId: 'poro',
    keycapId: 'fuji',
    plateId: 'alu',
    soundDescriptors: ['deep', 'poppy'],
    audio: "/audio/krush/krush_poro_ppefoam.mp3",
    youtube: "https://youtu.be/JdApE0gcmq0",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/krush651.jpg', 
    foam: ['Plate foam', 'PE foam'],
    mount: 'O-ring',
  },
  {
    id: 'b15',
    name: 'Mode Envoy',
    keyboardId: 'kb8',
    switchId: 'xinhai',
    keycapId: 'midnight',
    plateId: 'alu',
    soundDescriptors: ['bright', 'clacky', 'sharp'],
    audio: "/audio/envoy/envoy_xinhai.mp3",
    youtube: "https://youtu.be/m_fkKixJPpQ",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/modeenvoy1.jpg', 
    foam: [],
    mount: 'Green Lattice Block',
  },
  {
    id: 'b16',
    name: 'Mode Encore',
    keyboardId: 'kb6',
    switchId: 'y1x',
    keycapId: 'modern_materials_stone',
    plateId: 'alu',
    soundDescriptors: ['clacky', 'sharp'],
    audio: "/audio/encore/encore_y1x.mp3",
    youtube: "https://youtu.be/ts48gGKD1pQ",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/modeencore1.jpg', 
    foam: [],
    mount: 'Isolated Top Mount',
  },
  {
    id: 'b17',
    name: 'Pavlov',
    keyboardId: 'kb14',
    switchId: 'smoothie',
    keycapId: 'fuji',
    plateId: 'pc',
    soundDescriptors: ['poppy', 'clacky'],
    audio: "/audio/pavlov/pavlov_smoothie_afoam.mp3",
    youtube: "https://youtu.be/8e1EwbDjfyY",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/pavlov1.jpg', 
    foam: ['Case foam', 'Plate foam', 'PE foam'],
    mount: 'Gasket Tadpole',
  },
  {
    id: 'b18',
    name: 'Mode Envoy',
    keyboardId: 'kb7',
    switchId: 'milky_yellow',
    keycapId: 'bow',
    plateId: 'alu',
    soundDescriptors: [],
    audio: "/audio/envoy/envoypc_milkyyellow_green.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: '', 
    foam: [],
    mount: 'Green Lattice Block',
  },
  {
    id: 'b19',
    name: 'Mode Envoy',
    keyboardId: 'kb7',
    switchId: 'nixie',
    keycapId: 'night_sakura',
    plateId: 'alu',
    soundDescriptors: [],
    audio: "/audio/envoy/envoypc_nixies_green.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: '', 
    foam: [],
    mount: 'Green Lattice Block',
  },
  {
    id: 'b20',
    name: 'Mode Envoy',
    keyboardId: 'kb7',
    switchId: 'milky_yellow',
    keycapId: 'bow',
    plateId: 'alu',
    soundDescriptors: [],
    audio: "/audio/envoy/envoypc_milkyyellow_black.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: '', 
    foam: [],
    mount: 'Black Lattice Block',
  },
  {
    id: 'b21',
    name: 'Mode Envoy',
    keyboardId: 'kb7',
    switchId: 'nixie',
    keycapId: 'night_sakura',
    plateId: 'alu',
    soundDescriptors: [],
    audio: "/audio/envoy/envoypc_nixies_black.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: '', 
    foam: [],
    mount: 'Black Lattice Block',
  },
  {
    id: 'b22',
    name: 'Mode Envoy',
    keyboardId: 'kb8',
    switchId: 'nixie',
    keycapId: 'midnight',
    plateId: 'alu',
    soundDescriptors: ['scratchy', 'poppy'],
    audio: "/audio/envoy/envoy_nixies.mp3",
    youtube: "https://youtu.be/DLZp2YKgqd0",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/modeenvoy2.jpg', 
    foam: [],
    mount: 'Green Lattice Block',
  },
  {
    id: 'b23',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'purple_dawn',
    keycapId: 'night_sakura',
    plateId: 'cf',
    soundDescriptors: ['poppy', 'clacky', 'bright'],
    audio: "/audio/neo65cu/neo65cu_kgpd.mp3",
    youtube: "https://youtu.be/Zg0TVPupuOo",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neo65cu3.jpg',
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b24',
    name: 'DK1-TKL',
    keyboardId: 'kb16',
    switchId: 'mxblack',
    keycapId: '8008_bloo',
    plateId: 'alu',
    soundDescriptors: ['clacky', 'bright'],
    audio: "/audio/dk1_tkl/dk1_tkl_mx2a_softgasket.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: '',
    foam: [],
    mount: 'Soft Gasket',
  },
  {
    id: 'b26',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'yuying_tactile',
    keycapId: 'frost_witch',
    plateId: 'cf',
    soundDescriptors: [],
    audio: "/audio/wingtree/neo65cu_yuying_tactile.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: '',
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b27',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'yunie_linear',
    keycapId: 'frost_witch',
    plateId: 'cf',
    soundDescriptors: [],
    audio: "/audio/wingtree/neo65cu_yunie_linear.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: '',
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b28',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'yunie_tactile',
    keycapId: 'frost_witch',
    plateId: 'cf',
    soundDescriptors: [],
    audio: "/audio/wingtree/neo65cu_yunie_tactile.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: '',
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b29',
    name: 'Cycle8',
    keyboardId: 'kb3',
    switchId: 'sugar_rush',
    keycapId: 'darling',
    plateId: 'alu',
    soundDescriptors: ["clacky", "full"],
    audio: "/audio/cycle8/cycle8_sugar_rush_cpfoam.mp3",
    youtube: "https://youtu.be/R4m-2RoqCsI",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/cycle81.jpg',
    foam: ['Case Foam', "Plate Foam"],
    mount: 'Oring Gaskets',
  },
  {
    id: 'b30',
    name: 'Mode Encore',
    keyboardId: 'kb6',
    switchId: 'xinhai',
    keycapId: 'modern_materials_stone',
    plateId: 'alu',
    soundDescriptors: ["clacky", "bright", "poppy"],
    audio: "/audio/encore/encore_xinhai.mp3",
    youtube: "https://youtu.be/36Ws35aH38c",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/modeencore2.jpg',
    foam: [],
    mount: 'Isolated Top Mount',
  },
  {
    id: 'b31',
  name: 'QK65',
    keyboardId: 'kb15',
    switchId: 'smoothie',
    keycapId: 'oblivion',
    plateId: 'pom',
    soundDescriptors: ["thocky", "deep", "poppy", "marbly"],
    audio: "/audio/qk65/qk65_smoothie_pcfoam.mp3",
    youtube: "https://youtu.be/usDHOCdY-Ew",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/qk651.jpg',
    foam: [],
    mount: 'Gasket Socks',
  },
  {
    id: 'b32',
    name: 'Krush65',
    keyboardId: 'kb5',
    switchId: 'nixie',
    keycapId: 'fuji',
    plateId: 'alu',
    soundDescriptors: ["clacky", "bright", "scratchy"],
    audio: "/audio/krush/krush_nixie_pecfoam.mp3",
    youtube: "https://youtu.be/xLRV0bob6UI",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/krush652.jpg',
    foam: [],
    mount: 'Oring',
  },
  {
    id: 'b33',
    name: 'Neo Ergo',
    keyboardId: 'kb12',
    switchId: 'yunie_tactile',
    keycapId: '8008',
    plateId: 'pp',
    soundDescriptors: ["deep", "thocky", "poppy"],
    audio: "/audio/neoergo/neoergo_yunie_tactile_pcfoam.mp3",
    youtube: "https://youtu.be/CGtDYTo6KIo",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neoergogray2.jpg',
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b34',
    name: 'Krush65',
    keyboardId: 'kb5',
    switchId: 'yunie_linear',
    keycapId: 'midnight',
    plateId: 'alu',
    soundDescriptors: ["clacky", "poppy"],
    audio: "/audio/krush/krush_yunie_linear.mp3",
    youtube: "https://youtu.be/Xi4IH544Q-s",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/krush653.jpg',
    foam: [],
    mount: 'Oring',
  },
  {
    id: 'b25',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'yuying_linear',
    keycapId: 'frost_witch',
    plateId: 'cf',
    soundDescriptors: ["scratchy", "bright", "clacky"],
    audio: "/audio/wingtree/neo65cu_yuying_linear.mp3",
    youtube: "https://youtu.be/rJNvyHqtY4g",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neo65cu4.jpg',
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b35',
    name: 'Mode Envoy',
    keyboardId: 'kb8',
    switchId: 'yuying_linear',
    keycapId: 'fuji',
    plateId: 'alu',
    soundDescriptors: ["scratchy", "bright", "clacky"],
    audio: "/audio/envoy/envoy_yuying_linear.mp3",
    youtube: "https://youtu.be/1gfzjFrcHGI",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/modeenvoy3.jpg',
    foam: [],
    mount: 'Green Lattice Block',
  },
  {
    id: 'b36',
    name: 'Mode Encore',
    keyboardId: 'kb6',
    switchId: 'caramel_latte',
    keycapId: 'fuji',
    plateId: 'alu',
    soundDescriptors: ["deep", "crispy", "poppy"],
    audio: "/audio/encore/encore_caramel_latte.mp3",
    youtube: "https://youtu.be/p3M0dKmkvrU",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/modeencore3.jpg',
    foam: [],
    mount: 'Isolated Top Mount',
  },
  {
    id: 'b37',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'cheese',
    keycapId: 'digital_nightmares',
    plateId: 'pp',
    soundDescriptors: ["bright", "clacky"],
    audio: "/audio/neo65cu/neo65cu_cheese.mp3",
    youtube: "https://youtu.be/ipEfcSOrwtU",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neo65cu6.jpg',
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b38',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'sugar_rush',
    keycapId: 'digital_nightmares',
    plateId: 'pp',
    soundDescriptors: ["bright", "clacky"],
    audio: "/audio/neo65cu/neo65cu_sugar_rush.mp3",
    youtube: "https://youtu.be/1nOv0Q3gqQk",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neo65cu5.jpg',
    foam: [],
    mount: 'Isolated Top Mount',
  },
  {
    id: 'b39',
    name: 'BD60',
    keyboardId: 'kb1',
    switchId: 'yuying_tactile',
    keycapId: 'tuzi',
    plateId: 'pc',
    soundDescriptors: ['poppy', 'moderate', 'soft'],
    audio: "/audio/bd60/bd60_yuying_tactile.mp3",
    youtube: "",
    hasSoundtest: true,
    thumbnail: "/pictures/build_thumbnails/bd601.jpg",
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b40',
    name: 'Mode Envoy',
    keyboardId: 'kb8',
    switchId: 'poro',
    keycapId: 'midnight',
    plateId: 'alu',
    soundDescriptors: ["poppy", "bright", "clacky"],
    audio: "/audio/envoy/envoy_poro.mp3",
    youtube: "https://youtu.be/uhCmgAzpt6s",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/modeenvoy4.jpg',
    foam: [],
    mount: 'Green Lattice Block',
  },
  {
    id: 'b41',
    name: 'Mode Envoy',
    keyboardId: 'kb7',
    switchId: 'yogurt',
    keycapId: 'fuji',
    plateId: 'alu',
    soundDescriptors: ["bright", "clacky", "glassy"],
    audio: "/audio/envoy/envoypc_yogurts.mp3",
    youtube: "https://youtu.be/aMMifyvZyVc",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/modeenvoypc1.jpg',
    foam: [],
    mount: 'Green Lattice Block',
  },
  {
    id: 'b42',
    name: 'Neo Ergo',
    keyboardId: 'kb13',
    switchId: 'purple_dawn',
    keycapId: 'bow',
    plateId: 'pp',
    soundDescriptors: ['deep', 'thocky', 'marbly'],
    audio: "/audio/neoergo/neoergo_purpledawn_afoam.mp3",
    youtube: "https://youtu.be/92hAAS224ww",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neoergo2.jpg',
    foam: ['Case foam', 'Plate foam', 'PE foam'],
    mount: 'Gasket',
  },
  {
    id: 'b43',
    name: 'Neo Ergo',
    keyboardId: 'kb12',
    switchId: 'y3',
    keycapId: '8008',
    plateId: 'pp',
    soundDescriptors: ['deep', 'thocky', 'marbly'],
    audio: "/audio/neoergo/neoergo_y3_afoam.mp3",
    youtube: "https://youtu.be/n5JMjYJY8IM",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neoergogray3.jpg',
    foam: ['Case foam', 'Plate foam', 'PE foam'],
    mount: 'Gasket',
  },
  {
    id: 'b44',
    name: 'Cycle8',
    keyboardId: 'kb3',
    switchId: 'nixie',
    keycapId: 'darling',
    plateId: 'alu',
    soundDescriptors: ["clacky", "scratchy", 'quiet'],
    audio: "/audio/cycle8/cycle8_nixie.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: '',
    foam: [''],
    mount: 'Tadpole Gasket',
  },
  {
    id: 'b45',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'nixie',
    keycapId: 'dracula_r2',
    plateId: 'pp',
    soundDescriptors: ["bright", "clacky"],
    audio: "/audio/neo65cu/neo65cu_nixie.mp3",
    youtube: "https://youtu.be/dleGLxQQnKk",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neo65cu7.jpg',
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b46',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'xinhai',
    keycapId: 'night_sakura',
    plateId: 'pp',
    soundDescriptors: ["bright", "clacky"],
    audio: "/audio/neo65cu/neo65cu_xinhai.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: '',
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b47',
    name: 'Mode Encore',
    keyboardId: 'kb6',
    switchId: 'lunar_stone',
    keycapId: 'modern_materials_stone',
    plateId: 'alu',
    soundDescriptors: ["bright", "clacky"],
    audio: "/audio/encore/encore_lunar_stone.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: '',
    foam: [],
    mount: 'Green Lattice Block',
  },
  {
    id: 'b48',
    name: 'Brutal65 V2',
    keyboardId: 'kb2',
    switchId: 'smoothie',
    keycapId: 'honor_dark',
    plateId: 'alu',
    soundDescriptors: ['clacky', 'bright'],
    audio: "/audio/brutal/brutal_smoothie_afoam.mp3",
    youtube: "https://youtu.be/6kVp9yWIXvQ",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/brutal1.jpg',
    foam: ['Case foam', 'Plate foam', 'PE foam'],
    mount: 'Gasket',
  },
  {
    id: 'b49',
    name: 'Cycle8',
    keyboardId: 'kb3',
    switchId: 'cosmic_purple',
    keycapId: 'metropolis',
    plateId: 'alu',
    soundDescriptors: ["clacky", 'moderate'],
    audio: "/audio/cycle8/cycle8_cosmic_purple_cfoam.mp3",
    youtube: "https://youtu.be/XRUL0im9QC0",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/cycle82.jpg',
    foam: ['Case Foam'],
    mount: 'Tadpole Gasket',
  },
  {
    id: 'b50',
    name: 'Mode Encore',
    keyboardId: 'kb6',
    switchId: 'mxblack',
    keycapId: 'modern_materials_stone',
    plateId: 'alu',
    soundDescriptors: ["poppy", "scratchy"],
    audio: "/audio/encore/encore_mx2a2.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: '',
    foam: [],
    mount: 'Green Lattice Block',
  },
  {
    id: 'b51',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'y1x',
    keycapId: 'frost_witch',
    plateId: 'pp',
    soundDescriptors: ["bright", "clacky"],
    audio: "/audio/neo65cu/neo65cu_y1x.mp3",
    youtube: "https://youtu.be/sw5nDN5qlHk",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neo65cu8.jpg',
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b52',
    name: 'Pavlov',
    keyboardId: 'kb14',
    switchId: 'yunie_linear',
    keycapId: 'fishing',
    plateId: 'pc',
    soundDescriptors: ['deep', 'poppy'],
    audio: "/audio/pavlov/pavlov_yunie_linear_cpfoam.mp3",
    youtube: "https://youtu.be/3d_OxP7-3TQ",
    hasSoundtest: true,
    thumbnail: "/pictures/build_thumbnails/pavlov2.jpg",
    foam: ['Case foam', 'Plate foam'],
    mount: 'Gasket Tadpole',
  },
  {
    id: 'b53',
    name: 'Pavlov',
    keyboardId: 'kb14',
    switchId: 'smoothie',
    keycapId: 'midnight',
    plateId: 'fr4',
    soundDescriptors: ['clacky', 'bright'],
    audio: "/audio/pavlov/pavlov_smoothie_pfoam.mp3",
    youtube: "https://youtu.be/367N4ncYHjs",
    hasSoundtest: true,
    thumbnail: "/pictures/build_thumbnails/pavlov3.jpg",
    foam: ['Plate foam'],
    mount: 'Gasket Tadpole',
  },
  {
    id: 'b54',
    name: 'Neo65',
    keyboardId: 'kb9',
    switchId: 'hyacinth_v2',
    keycapId: '8008',
    plateId: 'pom',
    soundDescriptors: ['clacky', 'marbly'],
    audio: "/audio/neo65/neo65_hyacinthv2_afoam.mp3",
    youtube: "https://youtu.be/dEkXziF6TtY",
    hasSoundtest: true,
    thumbnail: "/pictures/build_thumbnails/neo651.jpg",
    foam: ['Plate foam, Case foam, PE foam'],
    mount: 'Gasket',
  },
  {
    id: 'b55',
    name: 'Neo Ergo',
    keyboardId: 'kb13',
    switchId: 'sugar_rush',
    keycapId: 'botanical',
    plateId: 'pp',
    soundDescriptors: ['full', 'deep', 'thocky'],
    audio: "/audio/neoergo/neoergo_sugarrush_cpfoam.mp3",
    youtube: "https://youtu.be/4qVEkyZ8BOI",
    hasSoundtest: true,
    thumbnail: "/pictures/build_thumbnails/neoergo3.jpg",
    foam: ['Plate foam, Case foam'],
    mount: 'Gasket',
  },
  {
    id: 'b56',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'yogurt',
    keycapId: 'frost_witch',
    plateId: 'pp',
    soundDescriptors: ["bright", "clacky"],
    audio: "/audio/neo65cu/neo65cu_yogurt_top.mp3",
    youtube: "https://youtu.be/5WCKOySsFrY",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neo65cu9.jpg',
    foam: [],
    mount: 'Isolated Top Mount',
  },
  {
    id: 'b57',
    name: 'Mode Envoy',
    keyboardId: 'kb7',
    switchId: 'macchiato',
    keycapId: 'honor_dark',
    plateId: 'alu',
    soundDescriptors: ["mid-pitched", "clacky", "mellow"],
    audio: "/audio/envoy/envoypc_macchiato.mp3",
    youtube: "https://youtu.be/2n5XW9lq66U",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/modeenvoy5.jpg',
    foam: [],
    mount: 'Green Lattice Block',
  },
  {
    id: 'b58',
    name: 'Neo70',
    keyboardId: 'kb11',
    switchId: 'yuying_tactile',
    keycapId: 'oblivion',
    plateId: 'pom',
    soundDescriptors: ['scratchy', 'deep', 'poppy'],
    audio: "/audio/neo70/neo70_yuyingtactile_pcfoam.mp3", 
    youtube: "https://youtu.be/4GRS_nX0KiI",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neo703.jpg',
    foam: ["Plate foam", "Case foam"],
    mount: 'O-ring',
  },
  {
    id: 'b59',
    name: 'Brutal65 V2',
    keyboardId: 'kb2',
    switchId: 'yunie_linear',
    keycapId: 'skidata_neo',
    plateId: 'alu',
    soundDescriptors: ['deep', 'mellow', 'marbly'],
    audio: "/audio/brutal/brutal_smoothie_afoam.mp3",
    youtube: "https://youtu.be/f7PmVy78wJg",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/brutal2.jpg',
    foam: ['Case foam', 'Plate foam', 'PE foam'],
    mount: 'Gasket',
  },
  {
    id: 'b60',
    name: 'Cycle8',
    keyboardId: 'kb3',
    switchId: 'mxblack',
    keycapId: 'night_sakura',
    plateId: 'alu',
    soundDescriptors: ["clacky", "scratchy", 'bright'],
    audio: "/audio/cycle8/cycle8_mx2a.mp3",
    youtube: "https://youtu.be/FCJuHBy8kJw",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/cycle83.jpg',
    foam: [],
    mount: 'Tadpole Gasket',
  },
  {
    id: 'b61',
    name: 'Neo Ergo',
    keyboardId: 'kb13',
    switchId: 'cloud',
    keycapId: 'blossom',
    plateId: 'pp',
    soundDescriptors: ['clacky', 'bright', 'poppy'],
    audio: "/audio/neoergo/neoergo_cloud.mp3",
    youtube: "https://youtu.be/G1YGltahooM",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neoergo4.jpg',
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b62',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'y2',
    keycapId: 'midnight',
    plateId: 'pp',
    soundDescriptors: ["deep", "thocky"],
    audio: "/audio/neo65cu/neo65cu_y2_afoam.mp3",
    youtube: "https://youtu.be/XX_qdtnpV7I",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neo65cu13.jpg',
    foam: ['Case foam', 'Plate foam', 'PE foam'],
    mount: 'Gasket',
  },
  {
    id: 'b63',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'jasmine_v2',
    keycapId: 'oblivion',
    plateId: 'cf',
    soundDescriptors: ["deep", "quiet", "thocky"],
    audio: "/audio/neo65cu/neo65cu_jasminev2.mp3",
    youtube: "https://youtu.be/IBAG0-29mh4",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neo65cu12.jpg',
    foam: [],
    mount: 'Gasket',
  },
  {
    id: 'b64',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'lunar_stone',
    keycapId: 'dracula_r2',
    plateId: 'pp',
    soundDescriptors: ["marbly", "foamy", "thocky"],
    audio: "/audio/neo65cu/neo65cu_lunarstone_afoam.mp3",
    youtube: "https://youtu.be/_T541A1RJfo",
    hasSoundtest: true,
    thumbnail: '/pictures/build_thumbnails/neo65cu11.jpg',
    foam: ['Case foam', 'Plate foam', 'PE foam'],
    mount: 'Gasket',
  },
  {
    id: 'b65',
    name: 'Neo65 Cu',
    keyboardId: 'kb10',
    switchId: 'yogurt',
    keycapId: 'frost_witch',
    plateId: 'pp',
    soundDescriptors: ["bright", "clacky"],
    audio: "/audio/neo65cu/neo65cu_yogurt.mp3",
    youtube: "",
    hasSoundtest: false,
    thumbnail: '/pictures/build_thumbnails/neo65cu10.jpg',
    foam: [],
    mount: 'Gasket',
  },
];



export default Builds;
